import { OrderCategory, OrderStatus } from "../../../../../api/endpoints/Order";
import React, { Fragment } from "react";
import { formatCurrency } from "../../../../../utils/Format";
import { serviceChargeCost, serviceChargeCostDiscount } from "../../../../../utils/Cost";
import LineItem from "../LineItem";
import { OrderCostSummaryV2PdfProps } from "../index";

const labelMapping = {
  [OrderCategory.REALTIME]: 'Service Charge (Volume and Service Package)',
  [OrderCategory.EU_CUTOUT]: 'Service Charge (Volume and Service Package)',
  [OrderCategory.ARCHIVE]: 'Annual ECMWF handling charge',
  [OrderCategory.WEB]: 'Annual ECMWF handling charge',
}

const ServiceChargeCost = (props: OrderCostSummaryV2PdfProps) => {
  const { cost, orderCategory, orderStatus, styles } = props;
  const { total_cost } = cost.data;

  if ((orderCategory === OrderCategory.REALTIME || orderCategory === OrderCategory.EU_CUTOUT) && orderStatus === OrderStatus.DRAFT) {
    return null;
  }

  if (!total_cost) {
    return null;
  }

  const isDiscounted = total_cost.service_charge !== total_cost.service_charge_after_discount;

  return (
    <Fragment>
      <LineItem styles={styles} label={labelMapping[orderCategory]} value={formatCurrency(serviceChargeCost(cost))} />

      {
        isDiscounted &&
        <LineItem
          styles={styles}
          label="Applicable discount"
          value={formatCurrency(serviceChargeCostDiscount(cost))}
        />
      }
    </Fragment>
  )
}

export default ServiceChargeCost;
